  <template>
  <SubContent @back="$router.go(-1)">
    <template v-slot:nav_left>
      运动能力测试
    </template>
    <div v-show="!loading" class="scroll_wrap">
      <vue-scroll>
        <div class="info_item">
          <div v-for="(item,index) in testData" :key="index" class="test-wrap">
            <div class="row over-hidden">
              <div class="col" style="border-bottom:1px solid #FFF; position: relative">
                <div class="col-tips" v-if="item.official===1" style="background-color:#eb2c2c;">
                  <span>官方测试</span>
                </div>
                <div class="col-tips" v-else style="border:1px solid">
                  <span>自行测试</span>
                </div>
                <div class="flex">
                  <span>测试时间：{{item.testTime | time() }}</span>
                </div>
                <div class="flex">
                  <span>测试批次：{{item.templateTitle}}</span>
                </div>
                <div class="flex">
                  <span>测试联系人：{{item.linkMen}}</span>
                  <span>测试联系人手机号：<yioks-privacy-text type="phone" :value="item.linkMenPhone" /></span>
                </div>
                <div class="flex">
                  <span>单位：{{ (item.organShortName || '--') + ' ' + (item.youthShortName || '--')}}</span>
                  <span>测试海拔 ：{{item.testRegion | testRegionFilter}}</span>
                </div>
                <div class="flex">
                  <span>测试地点 ：{{item.testAddress || '--'}}</span>
<!--                  <span style="display: flex;padding-left:10px">-->
<!--                    <span v-if="item.bodyResult" style="padding-left:0">排名 ：{{item.bodyResult.ranking || '&#45;&#45;'}}</span>-->
<!--                    <span v-if="item.bodyResult" style="padding-left:0">总分 ：{{item.bodyResult.score || '&#45;&#45;'}}</span>-->
<!--                  </span>-->
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="box-wrap">
                  <div
                    v-for="(itm,idx) in item.infoVos"
                    :key="itm.idNumber + idx"
                    class="box">
                    <p class="indicatorName" v-if="itm.score">{{itm.indicatorName}}&nbsp;/&nbsp;得分</p>
                    <p class="indicatorName" v-else>{{itm.indicatorName}}</p>
                    <p class="content">{{ itm.testResult || '--' }} &nbsp; <span v-if="itm.score">/&nbsp;{{itm.score}}</span></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vue-scroll>
    </div>
    <Pagination :total="total" :pageSize="size" :page.sync="page"/>
  </SubContent>
</template>

<script>

import body from '@/api/body'
import { testRegionFilter } from '@/utils/yioks_filter'
export default {
  components: {
    'SubContent': () => import('@/components/layout/newSubContent'),
    'Pagination': () => import('@/components/Pagination')
  },
  filters: {
    testRegionFilter
  },
  data () {
    return {
      testData: [],
      page: 0,
      size: 10,
      total: 0,
      playerUuid: '',
      loading: true
    }
  },
  watch: {
    page () {
      this.getPlayerBody()
    }
  },
  created () {
    this.playerUuid = this.$route.query.uuid || ''
    this.getPlayerBody()
  },
  methods: {
    getPlayerBody () {
      body.getPlayerBodyData(this.playerUuid, { page: this.page, size: this.size }).then(res => {
        if (res.code) {
          this.$message.error(res.msg)
          this.$router.go(-1)
        } else {
          this.loading = false
          this.testData = res.content
          this.total = res.totalPages
        }
      }).catch(err => {
        console.error(err)
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
.scroll_wrap
  height 100%
  padding 20px 0 10px 20px
  box-sizing border-box
  overflow hidden
  .info_item
    margin 0 30px 30px 10px
    .test-wrap
      border 1px solid #FFF
      margin-bottom 20px
      .row
        display flex
        .col
          flex 1
          .box-wrap
            flex 1
            display flex
            flex-wrap wrap
            justify-content space-around
            padding 10px 5px 0
            .box
              width 105px
              display flex
              flex-direction column
              // border-right 1px solid #FFF
              // border 1px solid #FFF
              margin-bottom 10px
              p
                flex 1
                display flex
                align-items center
                justify-content center
                min-height 40px
                text-align center
              .content
                border-top 1px dashed #FFF
              .indicatorName
                color #4cd964

          .flex
            display flex
            min-height 40px
            span
              flex 1
              line-height 40px
              padding-left 11px
        .label
          border-right 1px solid #FFF
          padding 15px
          display flex
          align-items center

  .col-tips {
    position:absolute;
    top: 16px;
    right: -28px;
    width: 120px;
    height: 28px;
    display: flex;
    justify-content:center;
    align-items:center;
    transform:rotate(42deg)
  }
  .over-hidden {
    overflow: hidden
  }
</style>
